import type { FC } from 'react';

const PreviewIcon: FC = () => (
    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62.69 73.73" height="16px">
        <path
            fill="#1a1446"
            d="M32.82,37.39A14.44,14.44,0,0,0,23.93,34l-.1,4a10.4,10.4,0,0,1,10,9l4-.52A14.35,14.35,0,0,0,32.82,37.39Z"
        />
        <rect fill="#1a1446" x="9.3" y="16.08" width="36.89" height="4" />
        <path fill="#1a1446" d="M4,66.1V0H2A2,2,0,0,0,0,2V68.1a2,2,0,0,0,2,2H45.23l-4.76-4Z" />
        <path
            fill="#1a1446"
            d="M60.88,64.78l-5.39-4.53V2a2,2,0,0,0-2-2H9.3V4H51.49V56.9l-7.67-6.43a17.63,17.63,0,0,0-2.23-17.66h4.6v-4H37.26a17.61,17.61,0,0,0-19.19,0H9.3v4h4.47A17.56,17.56,0,0,0,37.31,58.23L54.37,72.54a5,5,0,0,0,3.25,1.19l.45,0a5.07,5.07,0,0,0,2.81-8.93Zm-2.44,4.57a1.05,1.05,0,0,1-1.5.13L37.43,53.11l-1.28,1A13.58,13.58,0,1,1,39.59,50l-.79,1.43L58.31,67.84a1.11,1.11,0,0,1,.38.73A1.07,1.07,0,0,1,58.44,69.35Z"
        />
    </svg>
);
export default PreviewIcon;